export const ColorValues = {
  COMMON: "common",
  RED: "red",
  PINK: "pink",
  PURPLE: "purple",
  DEEPPURPLE: "deepPurple",
  INDIGO: "indigo",
  BLUE: "blue",
  LIGHTBLUE: "lightBlue",
  CYAN: "cyan",
  TEAL: "teal",
  GREEN: "green",
  LIGHTGREEN: "lightGreen",
  LIME: "lime",
  YELLOW: "yellow",
  AMBER: "amber",
  ORANGE: "orange",
  DEEPORANGE: "deepOrange",
  BROWN: "brown",
  GREY: "grey",
  BLUEGREY: "blueGrey"
};
